var map = {
	"./OtherProjects/codeChef1.png": 2002,
	"./OtherProjects/codeChef1.webp": 5366,
	"./OtherProjects/codeForces.png": 1480,
	"./OtherProjects/codeForces.webp": 6697,
	"./OtherProjects/gCloud.png": 9215,
	"./OtherProjects/gCloud.webp": 7252,
	"./OtherProjects/hashCode.png": 4656,
	"./OtherProjects/hashCode.webp": 6033
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1050;